var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadelW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4949 27.8622C23.4386 27.8622 20.1382 24.5618 20.1382 20.5055C20.1382 14.8272 24.7594 10.207 30.4377 10.207C34.494 10.207 37.7933 13.5074 37.7933 17.5637C37.7933 23.242 33.1732 27.8622 27.4949 27.8622Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2609 8.00002C23.3401 8.00002 17.739 13.6011 17.739 20.5219C17.739 26.7818 15.6524 29.5647 8 37.2182C8 38.7542 9.24579 40 10.7829 40C18.4353 32.3476 21.2182 30.261 27.4791 30.261C34.3988 30.261 39.9999 24.661 39.9999 17.739C39.9999 12.3564 35.6435 8.00002 30.2609 8.00002Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6547 26.3086C18.8382 28.8838 17.7393 30.2609 17.7393 30.2609C17.7393 30.2609 19.1163 29.1619 21.6916 28.3454C20.9159 27.7705 20.2296 27.0853 19.6547 26.3086Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1729 35.5865C31.1729 33.1491 33.149 31.173 35.5864 31.173C38.0237 31.173 39.9999 33.1491 39.9999 35.5865C39.9999 38.0238 38.0237 40 35.5864 40C33.149 40 31.1729 38.0238 31.1729 35.5865Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3563 31.1946C35.2934 32.3995 35.7061 33.6253 36.6274 34.5456C37.5476 35.4669 38.7735 35.8795 39.9784 35.8166",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8174 39.9778C35.8803 38.7729 35.4676 37.547 34.5463 36.6268C33.6261 35.7055 32.4002 35.2928 31.1953 35.3557",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadelW);
export default __webpack_public_path__ + "static/media/padel-w.a0451053c8040a817d092c8ebf8cae09.svg";
export { ForwardRef as ReactComponent };